import { bindActionCreators } from "@reduxjs/toolkit"
import { useMemo } from "react"
import { useAppDispatch } from "../../../../app/store/store"
import { GlobalMessageSlice } from "../../model/reducers/GlobalMessageSlice"


export const useGlobalMessageActions = () => {
    const dispatch = useAppDispatch()
    return useMemo(() => bindActionCreators(GlobalMessageSlice.actions, dispatch), [dispatch])
}
